import { render, staticRenderFns } from "./ManterHistoricoProduto.vue?vue&type=template&id=030c71b6"
import script from "./ManterHistoricoProduto.vue?vue&type=script&lang=ts"
export * from "./ManterHistoricoProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports